import createIdbStore from './idbStore';

export default createIdbStore('imageStore', {
  autoIncrement: false,
});
